import type MollieInput from '@Component/Mollie/Input/MollieInput';
import type {MollieComponent} from '@Component/Mollie/Input/Type/MollieComponent';

export default class MollieInputUI {
    public readonly component: MollieComponent;
    public readonly icon: HTMLElement;

    constructor(public readonly el: MollieInput) {
        this.component = window.mollie.createComponent(this.el.type, {styles: {base: {fontSize: '12px'}}});
        this.component.mount(this.el);

        this.icon = document.createElement('span');
        this.icon.classList.add('c-mollie-form-icon');
        if (this.el.type === 'cardNumber') {
            this.icon.classList.add('c-mollie-form-icon--extra-space');
        }
        this.el.append(this.icon);
    }
}
